import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where, getDocs, doc } from 'firebase/firestore';
import { db } from '../../utils/firebase';
import { getImageUrl } from '../../utils/imageUtils';

const MatchesGalleryView = ({ user, onProfileClick }) => {
    const [matchedProfiles, setMatchedProfiles] = useState([]);

    useEffect(() => {
        if (!user?.uid) return;

        const matchesRef = collection(db, 'matches');
        const q = query(matchesRef, where('participants', 'array-contains', user.uid));

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const userIds = new Set();
            snapshot.forEach(doc => {
                const data = doc.data();
                if (data.profile_ids?.id1 && data.profile_ids.id1 !== user.uid) {
                    userIds.add(data.profile_ids.id1);
                }
                if (data.profile_ids?.id2 && data.profile_ids.id2 !== user.uid) {
                    userIds.add(data.profile_ids.id2);
                }
            });

            const profilesRef = collection(db, 'users');
            const profilesSnapshot = await getDocs(profilesRef);
            const matched = [];

            profilesSnapshot.forEach(doc => {
                if (userIds.has(doc.id)) {
                    matched.push({ id: doc.id, ...doc.data() });
                }
            });

            setMatchedProfiles(matched);
        });

        return () => unsubscribe();
    }, [user]);

    const uniqueProfiles = [...new Map(matchedProfiles.map(profile => [profile.id, profile])).values()];

    const getProfileImageSrc = (imagePath) => {
        if (!imagePath) return '/avatars/1.png';
        if (imagePath.includes('avatars/')) return `/${imagePath}`;
        return getImageUrl(imagePath);
    };

    return (
        <div className="min-h-screen bg-white">
            <main className="p-4">
                <h1 className="text-2xl md:text-4xl font-bold text-center">Your <span className="text-black">best matches</span></h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
                    {uniqueProfiles.map((profile, index) => (
                        <div
                            key={`${profile.id}-${index}`}
                            className="relative bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
                        >
                            <div
                                onClick={() => onProfileClick(profile)}
                                className="cursor-pointer"
                            >
                                <div className="relative">
                                    <img
                                        src={getProfileImageSrc(profile.image)}
                                        alt={profile.name}
                                        className="w-full h-48 object-cover"
                                    />
                                    <div className="absolute bottom-0 right-0 bg-white/90 px-3 py-1 m-2 rounded-full">
                                        <span className="text-green-600 font-semibold">{profile.compatibility || 85}% Match</span>
                                    </div>
                                </div>
                                <div className="p-4">
                                    <h2 className="text-xl font-semibold">{profile.name}, {profile.age}</h2>
                                    <div className="mt-2 space-y-1">
                                        <p className="text-gray-600">
                                            <i className="fas fa-mountain mr-2"></i>
                                            {profile.skillLevel} Hiker
                                        </p>
                                        {profile.location && (
                                            <p className="text-gray-600">
                                                <i className="fas fa-map-marker-alt mr-2"></i>
                                                {profile.location}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default MatchesGalleryView;
